import { ImageMap, getImage, importAll } from "..";

declare const require: any;

const imagesRegulation: ImageMap = importAll(
  require.context("../regulation", false, /\.(png|jpe?g|svg)$/)
);

export default imagesRegulation;
export const getTemplateCultureImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(imagesRegulation).find(
    ([item, value], index) => getImage(item) === valueTemplateImage
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
